import { render } from "./asset-list-form.vue?vue&type=template&id=b1290b74"
import script from "./asset-list-form.vue?vue&type=script&lang=js"
export * from "./asset-list-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__